import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForEAtoOSBPremiumNonRTExperiment(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isInReverseTrial,
		isInCollection,
		invoiceableStatus,
		canAddPaymentDetails,
		addPaymentDetailsExperienceUrl,
	} = context;

	return Boolean(
		!isInCollection &&
		edition === 'premium' &&
		!isInReverseTrial &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		!!addPaymentDetailsExperienceUrl &&
		((product === 'jira' && isInTrial) ||
			(product === 'confluence' && (isInTrial || isInPredunning))) &&
		fg('ea-to-osb-premium-non-rt-kill-switch'),
	);
}
